import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Title } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MatRadioModule, MatButtonToggleModule } from '@angular/material';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { AlertComponent } from './components/alert/alert.component';
import { AppLayoutComponent } from './components/app-layout/app-layout.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoginComponent } from './components/login/login.component';
import { LoginLayoutComponent } from './components/login-layout/login-layout.component';
import { LogoutComponent } from './components/logout/logout.component';
import { NavComponent } from './components/nav/nav.component';
import { NavItemComponent } from './components/nav-item/nav-item.component';
import { ProductSelectComponent } from './components/product-select/product-select.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TestComponent } from './components/test/test.component';

import { OmsErrorHandlerService } from './services/oms-error-handler.service';
import { AuthenticationService } from './services/authentication.service';
import { ChartUpdateService } from './services/chart-update.service';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { LocaleService } from './services/locale.service';
import { MeterUsageDataService } from './services/meter-usage-data.service';
import { OfferEntryDataService } from './services/offer-entry-data.service';
import { OfferSummaryDataService } from './services/offer-summary-data.service';
import { AlertService } from './services/alert.service';
import { HeaderDataService } from './services/header-data.service';
import { DataService } from './services/data.service';
import { SpinnerService } from './services/spinner.service';
import { SocketService } from './services/socket.service';
import { MessageService } from './services/message.service';
import { OfferPriceDataService } from './services/offer-price-data.service';

import { LocaleResolveService } from './services/locale-resolve.service';
import { MenuResolveService } from './services/menu-resolve.service';

import { OmsRoutingModule } from '../oms-routing.module';

import { AuthGuard } from '../guard/auth-guard';
import { UserService } from './services/user.service';

import { SharedModule } from '../shared/shared.module';
import { EquipmentService } from './services/equipment.service';
import { NotificationService } from './services/notification.service';
import { UtilsService } from './services/utils.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatRadioModule, MatButtonToggleModule,
        TranslateModule,
        OmsRoutingModule,
        SharedModule
    ],
    declarations: [
        AlertComponent,
        FooterComponent,
        LoginLayoutComponent,
        LoginComponent,
        AppLayoutComponent,
        NavComponent,
        NavItemComponent,
        LogoutComponent,
        ProductSelectComponent,
        SpinnerComponent,
        TestComponent
    ],
    providers: [
        AuthGuard,
        Title,
        AlertService,
        AuthenticationService,
        OfferEntryDataService,
        MeterUsageDataService,
        OfferSummaryDataService,
        ChartUpdateService,
        DataService,
        HeaderDataService,
        MenuResolveService,
        LocaleService,
        LocaleResolveService,
        SpinnerService,
        SocketService,
        MessageService,
        UserService,
        EquipmentService,
        NotificationService,
        UtilsService,
        OfferPriceDataService,
        [{provide: HTTP_INTERCEPTORS, useClass: OmsErrorHandlerService, multi: true}],
        [{provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true}]
    ],
    exports: [
        AlertComponent,
        FooterComponent,
        LoginLayoutComponent,
        LoginComponent,
        AppLayoutComponent,
        NavComponent,
        NavItemComponent,
        LogoutComponent,
        ProductSelectComponent,
        SpinnerComponent,
        TestComponent,
        RouterModule
    ]
})
export class CoreModule {
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts